var map = {
	"./default.svg": "./src/images/cursors/FIGMA/default.svg",
	"./hover.svg": "./src/images/cursors/FIGMA/hover.svg",
	"./preview_1.svg": "./src/images/cursors/FIGMA/preview_1.svg",
	"./preview_2.svg": "./src/images/cursors/FIGMA/preview_2.svg",
	"./project_hover.svg": "./src/images/cursors/FIGMA/project_hover.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/cursors/FIGMA sync recursive ^\\.\\/.*\\.svg$";